import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function UpdateCell({ action, variables, setOpenVariable, visible }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.DATA-TABLE.UPDATE-CELL.';
    useEffect(() => {
        // Assign initial values
        if (!action.fields.tab) {
            action.fields.tab = { value: 'first' };
        }
    }, []);
    // Handle tab change
    // const handleClick = (e) => {
    //     let value = e.target.value;
    //     action.fields.tab = { value };
    //     setTab(value);
    // };
    // const displayData = (x, y) => {
    //     return data?.[y]?.[x];
    // };
    // // Handle table change
    // const onChange = (changes) => {
    //     const newData = [...data];
    //     for (const change of changes) {
    //         if (!newData[change.y]) {
    //             newData[change.y] = [];
    //         }
    //         newData[change.y][change.x] = change.value;
    //     }
    //     action.fields.column = { value: newData };
    //     setData(newData);
    // };
    // Handle cell value changes
    // const onCellsChanged = changes => {
    //     const grid = data.map(row => [...row]);
    //     changes.forEach(({ cell, row, col, value }) => {
    //         grid[row][col] = value;
    //     });
    //     action.fields.table = { value: grid };
    //     // Update state
    //     setData(grid);
    // };
    // // Handle removing row
    // const handleAddRow = (e) => {
    //     let newRow = [''];
    //     data.push(newRow);
    //     // Add new row
    //     setData([...data]);
    // };
    // // Handle removing row
    // const handleRemoveRow = (e) => {
    //     // Remove row
    //     if (data.length > 1) {
    //         data.pop();
    //         setData([...data]);
    //     }
    // };
    return (
        <div>
            <div className={`conf-field-container ${visible ? "display-none" : ""}`}>
                <FieldLabel name={t(label + 'SOURCE')} is_required />
                <VariablePicker action={action} inputName="sourceData" variables={variables}
                    setOpenVariable={setOpenVariable} filter="data table" isRequired hideRequired />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'ROW-INDEX')} is_required />
                <TextInput action={action} inputName="rowIndex" variables={variables}
                    setOpenVariable={setOpenVariable} include={['number']} fieldType="string"
                    displayName={t(label + 'ROW-INDEX')} isRequired hideRequired />
                <small className="conf-field-desc"><em>{t(label + 'ROW-INDEX-EG')}</em></small>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'COLUMN-INDEX')} is_required />
                <TextInput action={action} inputName="colIndex" variables={variables}
                    setOpenVariable={setOpenVariable} fieldType="string"
                    displayName={t(label + 'COLUMN-INDEX')} isRequired hideRequired />
                <small className="conf-field-desc"> <em>{t(label + 'COLUMN-INDEX-EG')}</em></small>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'VALUE')} is_required />
                <TextInput action={action} inputName="value" variables={variables}
                    setOpenVariable={setOpenVariable} fieldType="string" displayName={t(label + 'VALUE')} isRequired hideRequired />
            </div>
        </div>
    );
}

export default UpdateCell;
